/**
 * 单选中时的手柄层：根据 element.type 选择对应 Handles 子组件（见 handles/ 与 getHandlesComponent）。
 * 状态与交互逻辑由 Workspace 通过回调传入。
 */
import { getHandlesComponent, type HandlesProps } from './handles';
import type { ResizeHandle } from '@/components/canvas/transform';
import { selectionChromeWorldMetrics } from './selectionChrome';

export type { ResizeHandle } from '@/components/canvas/transform';

export type HandleLayerProps = HandlesProps;

export function HandleLayer(props: HandleLayerProps) {
  const { element: el, rect, rotation, zoom } = props;
  const { inset, pad } = selectionChromeWorldMetrics(zoom);
  const w = rect.width + pad;
  const h = rect.height + pad;
  const rot = rotation ?? el.layout.rotation;
  const HandlesComponent = getHandlesComponent(el.type);

  return (
    <div className="absolute inset-0 pointer-events-none z-[3]" aria-hidden>
      <div
        className="absolute pointer-events-none"
        style={{
          left: rect.x - inset,
          top: rect.y - inset,
          width: w,
          height: h,
          transform: `rotate(${rot}deg)`,
          transformOrigin: 'center center',
        }}
      >
        <HandlesComponent {...props} />
      </div>
    </div>
  );
}
